import React from 'react';

import '../style/Pagination.css';
const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
}) => {
  let pages = [];
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pages.push(i);
  }
  return (
    <div className='pagination_Btn'>
      {pages.map((page, index) => {
        return (
          <button
            key={index}
            onClick={() => setCurrentPage(page)}
            className={` px-2 hover:bg-violet-800 hover:text-white border-2 border-violet-800 mx-[10px] ${page}=== ${currentPage} ? 'active bg-violet-800' : 'bg-white'} `}
          >
            {page}
          </button>
        );
      })}
    </div>
  );
};

export default Pagination;
